import * as z from "zod";

export enum ForceDiscountReason {
  WELCOME = "WELCOME",
}

const ForceDiscountSchema_ = z.object({
  code: z.string().describe("The discount code to use"),
  discountId: z.string().describe("The discount ID to look up percentage"),
  reason: z
    .nativeEnum(ForceDiscountReason)
    .describe("Why this discount is being forced"),
  description: z
    .string()
    .optional()
    .describe("Human-readable description of the discount (e.g., '15% off')"),
});
export const ForceDiscountSchema: z.ZodType<ForceDiscount> =
  ForceDiscountSchema_;
export interface ForceDiscount extends z.infer<typeof ForceDiscountSchema_> {}
